module.exports = __webpack_public_path__ + "static/img/UA.e42f77fa.png";